// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.efKkf9pzkEPbcdwlgJBz {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0.5rem;
  gap: 1rem;
  border-bottom: 1px solid pink;
}
.efKkf9pzkEPbcdwlgJBz .efKkf9pzkEPbcdwlgJBz:last-child {
  border-bottom: 0.1vmin solid var(--tan-3);
}
.efKkf9pzkEPbcdwlgJBz .UcikO_CqFcARKDTAJUzd {
  color: yellow;
  text-shadow: 2px 2px 2px black;
}
.efKkf9pzkEPbcdwlgJBz .SdEPtntWPAbiIXuBpYBC {
  margin-top: 1rem;
}
.efKkf9pzkEPbcdwlgJBz .gaQKddGTr16dCrKJflpv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.25rem;
}
.efKkf9pzkEPbcdwlgJBz .gaQKddGTr16dCrKJflpv .WVAZURX4ddcE5kHjjU0h {
  margin: auto 1rem;
}
.efKkf9pzkEPbcdwlgJBz .HFg6tMzXSDMil67LO1j3 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25rem;
}
.efKkf9pzkEPbcdwlgJBz .aGhv4adQxdYglzM8MSrN {
  margin: 0;
  height: 2rem;
  width: 2rem;
  background-color: red;
}`, "",{"version":3,"sources":["webpack://./src/components/LineGame/LineGame.module.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,6BAAA;AACJ;AACI;EACI,yCAAA;AACR;AAEI;EACI,aAAA;EACA,8BAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAII;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAFR;AAIQ;EACI,iBAAA;AAFZ;AAMI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAJR;AAOI;EACI,SAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;AALR","sourcesContent":[".LineGame {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-bottom: .5rem;\n    gap: 1rem;\n    border-bottom: 1px solid pink;\n\n    .LineGame:last-child {\n        border-bottom: .1vmin solid var(--tan-3);\n    }\n\n    .lineGameName {\n        color: yellow;\n        text-shadow: 2px 2px 2px black;\n    }\n    \n    .lineGamePrice {\n        margin-top: 1rem;\n    }\n\n    .qty {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 1.25rem;\n\n        .currentQty {\n            margin: auto 1rem;\n        }\n    }\n\n    .extPrice {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 1.25rem;\n    }\n\n    .button {\n        margin: 0;\n        height: 2rem;\n        width: 2rem;\n        background-color: red;\n    }\n}\n    \n\n    \n\n    \n\n    \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LineGame": `efKkf9pzkEPbcdwlgJBz`,
	"lineGameName": `UcikO_CqFcARKDTAJUzd`,
	"lineGamePrice": `SdEPtntWPAbiIXuBpYBC`,
	"qty": `gaQKddGTr16dCrKJflpv`,
	"currentQty": `WVAZURX4ddcE5kHjjU0h`,
	"extPrice": `HFg6tMzXSDMil67LO1j3`,
	"button": `aGhv4adQxdYglzM8MSrN`
};
export default ___CSS_LOADER_EXPORT___;
